import { z } from 'zod';

/** Teto defensivo de um valor de entrada (reais ou moeda estrangeira): sem regra de valor máximo no
 *  legado nem no BFF, é só uma barreira contra lixo e overflow — o saldo e a política recusam
 *  antes disso. */
export const VOLL_WALLET_MAX_AMOUNT = 10_000_000;

/** Um valor monetário enviado pelo cliente: positivo, até o teto e em centavos. A checagem em
 *  centavos (`Math.round(v*100)/100 === v`) evita o erro de ponto flutuante do `multipleOf(0.01)`
 *  (que recusa 0.07 e 1234.56). O que a tela manda (centavos / 100) sempre passa. */
export const VollWalletMoneyInputSchema = z
  .number()
  .positive()
  .max(VOLL_WALLET_MAX_AMOUNT)
  .refine((v) => Math.round(v * 100) / 100 === v, { message: 'at most 2 decimal places' });

/** An amount in a foreign receipt's own currency: up to three decimals, the most an ISO 4217
 *  currency has (the Kuwaiti dinar's fils). The expenses-api keeps it as a float and rounds only
 *  the total in reais to cents (`calculateTotalReceipt`); the amount in reais stays
 *  `VollWalletMoneyInputSchema`. */
export const VollWalletCurrencyAmountSchema = z
  .number()
  .positive()
  .max(VOLL_WALLET_MAX_AMOUNT)
  .refine((v) => Math.round(v * 1000) / 1000 === v, { message: 'at most 3 decimal places' });

/** Teto das listas de entrada (carteiras do pedido, campos da empresa). */
export const VOLL_WALLET_MAX_LIST = 50;
